import React, { useContext, useState } from 'react';
import Button from 'components/Atoms/Button';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import styled from 'styled-components';
import { tc } from 'utils/theme';

import { AppContext } from 'contexts/AppContext';
import SuccessIcon from 'components/Molecules/SuccessMessage/SuccessIcon';

const H2 = loadable(() => import('components/Atoms/H2'));
const Logo = loadable(() => import('components/Atoms/Logo'));
const Link = loadable(() => import('components/Atoms/Link'));
const Icon = loadable(() => import('components/Atoms/Icon'));
const LayoutAuth = loadable(() => import('components/Organisms/LayoutAuth'));
const Form = loadable(() => import('components/Organisms/FormResetPassword'));

const Content = styled.div`
  max-width: 400px;
  margin: 0 auto;
`;

const StyledLogo = styled(Logo)`
  width: 100%;
  height: 140px;
`;

const StyledText = styled.p`
  text-align: center;
  margin: 30px 0;
`;

const StyledIcon = styled(Icon)`
  && {
    font-size: 50px;
    color: ${tc('circleActiveColor')};
  }
`;

const ResetPassword = ({
  match: {
    params: { resetToken },
  },
}) => {
  const { organizationId, propertyId } = useContext(AppContext);

  const [success, setSuccess] = useState(false);

  const onSubmitSuccess = () => {
    setSuccess(true);
  };

  const RenderForm = () => (
    <>
      <H2 center>Change Your Password</H2>
      <Form resetToken={resetToken} onSubmitSuccess={onSubmitSuccess} />
      <StyledText>
        <Link to={`/${organizationId}/${propertyId}`}>Return to Login</Link>
      </StyledText>
    </>
  );

  const RenderSuccess = () => (
    <>
      <H2 center>Password Reset Successful!</H2>
      <StyledText>
        <SuccessIcon />
      </StyledText>
      <StyledText>
        Your password has been updated! You may now use your new password to log
        in.
      </StyledText>
      <StyledText>
        <Button variant={'primary'} to={`/${organizationId}/${propertyId}`}>
          Go to Login
        </Button>
      </StyledText>
    </>
  );

  return (
    <LayoutAuth>
      <Content>
        <StyledLogo padBottom />
        {success === false && <RenderForm />}
        {success === true && <RenderSuccess />}
      </Content>
    </LayoutAuth>
  );
};

ResetPassword.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      resetToken: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default ResetPassword;
